import { render, staticRenderFns } from "./detalhesEnvio.vue?vue&type=template&id=d8739b88&scoped=true&"
import script from "./detalhesEnvio.vue?vue&type=script&lang=js&"
export * from "./detalhesEnvio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8739b88",
  null
  
)

export default component.exports